<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_3">Acknowledgement</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_8"><span class="text_2">I want to thank Sarah Jackson, school secretary of Gorsewood Primary School, Runcorn, for her longstanding patience over the slow period of production of the novel.</span></p>
<p class="block_3" id="calibre_pb_3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?3a371ea0